/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { forwardRef, ForwardedRef } from 'preact/compat';
import { cssProps } from '@oracle/oraclejet-cssprops';

type Props = {
  onFocus: (event: FocusEvent) => void;
};

const styles = {
  guard: cssProps`${{
    height: '0px',
    left: 0,
    position: 'fixed',
    top: 0,
    width: '1px'
  }}`
};

/**
 * Styled FocusTrap sub-component to render non-visible focus guards
 */
const FocusGuard = forwardRef(({ onFocus }: Props, guardRef: ForwardedRef<HTMLDivElement>) => {
  return <div class={styles.guard} onFocus={onFocus} ref={guardRef} tabIndex={0} />;
});

export default FocusGuard;
